<app-auth-shell>
  <img
    src="./assets/images/logos/incidite-head-white.svg"
    alt="Incidite"
    class="h-6 w-auto self-start" />

  <h1 class="mt-5 text-2xl leading-6.5 tracking-tight text-zinc-50">
    @if (invitation(); as invite) {
      {{
        'pages.auth.register.inviteTitle'
          | transloco: { organizationName: invite.organization.name }
      }}
    } @else {
      {{ 'pages.auth.register.title' | transloco }}
    }
  </h1>
  <p class="mt-3 text-sm tracking-tight text-zinc-400">
    @if (invitation()) {
      {{ 'pages.auth.register.inviteSubtitle' | transloco }}
    } @else {
      {{ 'pages.auth.register.subtitle' | transloco }}
    }
  </p>

  @if (providers().length) {
    <app-oidc-buttons
      class="mt-7"
      intent="register"
      [providers]="providers()"
      [busy]="busy()"
      (picked)="signUpWith($event)" />
    <hr class="mt-8 border-zinc-800" />
  }

  <form
    class="mt-8 flex flex-col gap-5 rounded-2xl bg-zinc-800 p-5 inset-ring inset-ring-zinc-750"
    [formGroup]="form"
    (ngSubmit)="submit()"
    novalidate>
    <vx-form-field [label]="'pages.auth.register.emailLabel' | transloco">
      <vx-input
        size="lg"
        type="email"
        formControlName="email"
        autocomplete="email"
        [placeholder]="'pages.auth.register.emailPlaceholder' | transloco" />
    </vx-form-field>

    @if (messages().length) {
      <app-kratos-messages [messages]="messages()" />
    }

    <div class="flex flex-col gap-3">
      <vx-button type="submit" size="lg" [fullWidth]="true" [loading]="busy()">
        {{ 'pages.auth.register.submit' | transloco }}
      </vx-button>
      <p class="text-center text-xs leading-5 tracking-tight text-zinc-400">
        {{ 'pages.auth.register.codeHint' | transloco }}
      </p>
    </div>
  </form>

  <p class="mt-4 text-center text-xs leading-5 tracking-tight text-zinc-400">
    {{ 'pages.auth.register.terms.before' | transloco }}
    <a
      class="text-zinc-300 underline underline-offset-2 hover:text-zinc-100"
      href="https://incidite.com/legal/terms-and-conditions"
      target="_blank"
      rel="noopener"
      >{{ 'pages.auth.register.terms.termsLink' | transloco }}</a
    >{{ 'pages.auth.register.terms.middle' | transloco }}
    <a
      class="text-zinc-300 underline underline-offset-2 hover:text-zinc-100"
      href="https://incidite.com/legal/privacy-policy"
      target="_blank"
      rel="noopener"
      >{{ 'pages.auth.register.terms.privacyLink' | transloco }}</a
    >{{ 'pages.auth.register.terms.after' | transloco }}
  </p>

  <p class="mt-6 text-center text-sm tracking-tight text-zinc-400">
    {{ 'pages.auth.register.haveAccount' | transloco }}
    <a
      class="font-medium text-zinc-200 underline underline-offset-2 hover:text-zinc-50"
      routerLink="/login">
      {{ 'pages.auth.register.login' | transloco }}
    </a>
  </p>
</app-auth-shell>
